export const featureFlags = {
    WebappPreviewEnabled: 'webappPreviewEnabled',
    FrictionlessOnboardingEnabled: 'frictionlessOnboardingEnabled'
};


// WEBPACK FOOTER //
// ./src/scripts/services/featureFlags.const.js